import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { CartRow, CartService, BaseViewConfigService,ProductAssortmentParentService } from 'gung-standard';
import { CultSalesCartListComponent } from '../components/cult-sales-cart-list/cult-sales-cart-list.component';
import { JeevesSalesCartConfigService } from 'gung-standard-jeeves';

@Injectable({
  providedIn: 'root'
})
export class CultSalesCartConfigService extends JeevesSalesCartConfigService {
  constructor(protected cartService: CartService, baseViewConfigService: BaseViewConfigService, productAssortmentParentService: ProductAssortmentParentService) {
    super(cartService, baseViewConfigService, productAssortmentParentService);
  }

  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart table',
        getListItemComponent: () => CultSalesCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
